import {store} from '../../../store/store'
import page from '../../../components/page'
import search from '../../../components/search'
import activity from '../../../components/activity.vue'
import {api} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {StorageUtil, LocalStorageUtil} from '../../../common/Auth.js';

export default {
  name: "activitylist",
  data() {
    return {
        imgError: store.imgError,
        idS:[],
        libCode:'',
        locationCode:'',
        latLng:'',
        libName:'',
        libLevel:'',
        libId:0,
        pageCount:3,
        pageNo:1,
        libraryNewsData:{},
        totalPage:0,
    }
  },
  components: {
    page,
    search,
    activity
  },
  beforeMount() {
    store.libraryNav.activeNav = '本馆活动';
    this.queryData();
  },
    watch: {
        $route() {
            this.queryData();
        }
    },
  methods: {
    queryData(){
        this.libCode = this.$route.query.libCode;
        this.locationCode = this.$route.query.code || store.chooseArea.code;
        this.latLng = this.$route.query.latLng || store.localtionArea.latLng;
        this.libName = this.$route.query.libName;
        this.libLevel = this.$route.query.libLevel;
        this.libId = this.$route.query.libId;
        this.pageNo = this.$route.query.page || 1;
        var url = api.activity.activitys.replace('{libCode}',this.libCode).replace('{pageCount}', this.pageCount).replace('{pageNo}', this.pageNo).replace('{keyword}', "");
         ajaxUtil.ajaxJson(url,null,"GET",(data)=>{
             this.libraryNewsData = data;
             this.totalPage=data.totalPage;
             this.pageNo=data.pageNo;
            if (this.libraryNewsData.totalCount>0){
                for (var i=0;i<this.libraryNewsData.resultList.length;i++){
                    this.idS.push(this.libraryNewsData.resultList[i].id);
                }
            }
        },null,this);
    },

    intoInformationActivityDetail(id){
      var data = {
        ids: this.idS,
        totalCount: this.libraryNewsData.totalCount,
        pageCount: this.pageCount,
        pageNo: this.pageNo,
        totalPage: this.libraryNewsData.totalPage
      };
      StorageUtil.storeObject("activityInfo", data);
      this.$router.push({path: '/activityDetails', query: {activityId: id, code: this.locationCode,libCode:this.$route.query.libCode}});
    },
    paging: function (pageNo) {
      CommonUtil.mergeQuery(this,{page: pageNo})
    },

  }
}
